import { SxProps } from "@mui/material";
import { ReactNode } from "react";

export type MenuItemType<T> = {
  value: T;
  label: string | ReactNode;
  disabled?: boolean;
}

export type Props<T> = {
  onClick: (value: T) => void;
  selectedValue: T;
  menuItems: MenuItemType<T>[];
  menuType?: MenuType;
  sx?: SxProps;
  labelText?: string;
  actionIcon?: ReactNode;
};

export enum MenuType {
  outlined = 'outlined',
  contained = 'contained'
}
